export default __webpack_public_path__ + "static/media/login-human-icon.c2d486e4.svg";